import ChevronDownIcon from "@heroicons/react/24/outline/ChevronDownIcon";
import * as Accordion from "@radix-ui/react-accordion";
import clsx from "clsx";
import React from "react";
import TDIcon from "../TDIcon";
import { TDAccordionItemProps, TDAccordionProps } from "./TDAccordion.types";

export default function TDAccordionItem({
  title,
  badgeNum,
  content,
}: TDAccordionItemProps) {
  return (
    <>
      <Accordion.Trigger
        className="hover:bg-slate-150 group rdx-state-open:bg-slate-100 
    hover:rdx-state-open:bg-slate-200 ease-out transition-colors px-5 py-2 w-full flex 
flex-row justify-between items-center space-x-4 rounded-full"
      >
        <span className="flex flex-row flex-nowrap justify-center items-center space-x-2">
          <div className="min-w-[28px] flex flex-row items-center justify-center w-auto">
            {badgeNum && (
              <div
                className="text-[8px] min-w-[18px] min-h-[18px] inline-flex 
        h-auto justify-center items-center text-white bg-primary px-1.5 py-0.5 rounded-full"
              >
                {badgeNum}
              </div>
            )}
          </div>
          <div>{title}</div>
        </span>
        <TDIcon
          iconSize="xs"
          className="group-rdx-state-open:rotate-180 transition-transform ease-out"
        >
          <ChevronDownIcon />
        </TDIcon>
      </Accordion.Trigger>
      <Accordion.Content className="py-2 ml-5 text-sm text-slate-500">
        {content}
      </Accordion.Content>
    </>
  );
}
